import { useEffect, useState } from "react";

function PitchImageGallery({ images }) {
  if (!images || images.length === 0) {
    return (
      <p className="text-gray-500 text-center py-4">
        No images available for this pitch.
      </p>
    );
  }

  const [mainImage, setMainImage] = useState(images[0]);
  const [isFullscreen, setIsFullscreen] = useState(false); // New state for fullscreen mode

  useEffect(() => {
    setMainImage(images[0]);
  }, [images]);

  // Toggle fullscreen mode when main image is clicked
  const handleImageClick = () => {
    setIsFullscreen(true);
  };

  // Close fullscreen mode
  const handleCloseFullscreen = () => {
    setIsFullscreen(false);
  };

  return (
    <div className="max-w-5xl mx-auto">
      {/* Main Image */}
      <div className="relative overflow-hidden rounded-2xl shadow-lg">
        <img
          src={mainImage}
          alt="Main Pitch View"
          className="w-full h-[32rem] object-cover transition-opacity duration-300 ease-in-out mobile-image cursor-pointer"
          onClick={handleImageClick} // Click to enlarge
        />
      </div>

      {/* Fullscreen Image View */}
      {isFullscreen && (
        <div className="fixed inset-0 bg-white bg-opacity-1 flex items-center justify-center z-50">
          <img
            src={mainImage}
            alt="Fullscreen Pitch View"
            className="w-full h-full object-contain max-w-[100vw] max-h-[90vh]"
          />
          {/* Close Button */}
          <button
            onClick={handleCloseFullscreen}
            className="absolute top-4 right-4 text-black text-4xl font-bold cursor-pointer hover:text-gray-300 transition-colors"
          >
            &times; {/* HTML entity for "X" */}
          </button>
        </div>
      )}

      {/* Thumbnail Gallery */}
      <div className="flex gap-3 mt-6 overflow-x-auto scrollbar-thin scrollbar-thumb-[#6ca87e] scrollbar-track-gray-100 pb-2 justify-center">
        {images.map((img, index) => (
          <img
            onClick={() => setMainImage(img)}
            key={index}
            src={img}
            alt={`Pitch Thumbnail ${index + 1}`}
            className={`w-24 h-24 object-cover rounded-lg shadow-md cursor-pointer transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
              mainImage === img
                ? "border-2 border-[#6ca87e] opacity-100"
                : "opacity-75 hover:opacity-100"
            }`}
          />
        ))}
      </div>

      {/* Inline CSS for Mobile and Fullscreen */}
      <style jsx>{`
        @media only screen and (max-width: 600px) {
          .mobile-image {
            width: 100vw !important; /* Full viewport width */
            height: 16rem; /* Reduced height for a more horizontal look */

            object-fit: cover; /* Ensures the image stretches/crops properly */
          }
        }
      `}</style>
    </div>
  );
}

export default PitchImageGallery;
